<template>
  <router-view />
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'AuthenticateToken',
  async created() {
    this.startLoading(this.$options.name);
    await this.init({
      incognito: this.$route.query.incognito,
      name: this.$route.name,
      phoneNumberFromQuery: this.$route.query.phoneNumber,
    });
    await this.initSourceFields();
    await this.initSubscriptionState();
    await this.initDiscountPromotion();
    await this.initBenefits();
    const query = { ...this.$route.query };
    delete query.phoneNumber;
    this.$router.replace({ query });
    this.doneLoading(this.$options.name);
  },
  methods: {
    ...mapActions('loader', ['startLoading', 'doneLoading']),
    ...mapActions('sourceFields', ['initSourceFields']),
    ...mapActions('session', ['init']),
    ...mapActions('subscriptionState', ['initSubscriptionState']),
    ...mapActions('discountPromotion', ['initDiscountPromotion']),
    ...mapActions('benefits', ['initBenefits']),
  },
};
</script>
